import { graphql } from '@/gql'

export const SharesFragment = graphql(/* GraphQL */ `
  fragment Shares on Job {
    recruiterShares: shares(isActive: true, accountTypes: [RECRUITER]) {
      paginatorInfo {
        total
      }
    }
    workerShares: shares(isActive: true, accountTypes: [WORKER]) {
      paginatorInfo {
        total
      }
    }
  }
`)

export const JobFormShareWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareWorker on JobShare {
    id
    account {
      ...JobFormShareableWorker
    }
  }
`)

export const JobFormShareRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareRecruiter on JobShare {
    id
    account {
      ...JobFormShareableRecruiter
    }
  }
`)

export const JobFormShareableWorkerFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableWorker on Worker {
    id
    name
    avatar
    jobTitle
  }
`)

export const JobFormShareableRecruiterFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableRecruiter on Recruiter {
    id
    name
    avatar
  }
`)

export const JobFormShareableCompanyFragment = graphql(/* GraphQL */ `
  fragment JobFormShareableCompany on Company {
    id
    name
    avatar
  }
`)
